import i18n from 'app-i18n';
import { isDateRangeValid } from 'components/forms/fields/date-range-field/date-range-field.utils';
import { DateTime } from 'luxon';
import * as yup from 'yup';

const isIn15MinuteInterval = (date: string) => {
  const parsedDate = DateTime.fromISO(date);
  return parsedDate.minute % 15 === 0;
};

export const setOrderLimitsFormSchema = yup.object().shape({
  orderLimitsType: yup
    .array()
    .of(yup.string())
    .min(1, () =>
      i18n.t('forms.setOrderLimitsForm.fields.orderLimitsType.errors.required'),
    )
    .default(['VALUE']),
  daysOfWeek: yup.array().required().min(1),
  timeRange: yup
    .array()
    .required()
    .test(
      'validTimeRange',
      () =>
        i18n.t(
          'forms.setOrderLimitsForm.fields.timeRange.errors.invalidTimeRange',
        ),
      isDateRangeValid,
    )
    .test(
      'isIn15MinuteInterval',
      () =>
        i18n.t(
          'forms.setOrderLimitsForm.fields.timeRange.errors.invalidInterval',
        ),
      timeRange => {
        if (isDateRangeValid(timeRange)) {
          const [startTime, endTime] = timeRange;
          return (
            isIn15MinuteInterval(startTime) && isIn15MinuteInterval(endTime)
          );
        }

        return true;
      },
    ),
  kitchenThrottleValue: yup
    .number()
    .nullable()
    .when('orderLimitsType', {
      is: (orderLimitsType: string[]) => orderLimitsType.includes('VALUE'),
      then: yup.number().nullable().required().min(1).max(10000),
    }),
  kitchenThrottleVolume: yup
    .number()
    .nullable()
    .when('orderLimitsType', {
      is: (orderLimitsType: string[]) => orderLimitsType.includes('VOLUME'),
      then: yup.number().nullable().required().min(1).max(10000),
    }),
});
